import { Box, Center, Spinner } from '@chakra-ui/react';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { LotType, ResourceType } from '../../_openapi/portfolio-optimizer';
import { useClosedLots } from '../../api/lot';
import { closedLotListColumns } from '../../Lot/closedLotListColumns';
import { Pagination } from '../../widgets/Table/Pagination';
import { Table } from '../../widgets/Table/Table';
import { TableControls } from '../../widgets/Table/TableControls';
import { useTableColumnSettings } from '../../widgets/Table/useTableColumnSettings';
import { useTableState } from '../../widgets/Table/useTableState';

export const PortfolioClosedLotsTableTab = ({ pId }: { pId: string }) => {
    const { pagination, setPagination, sorting, setSorting, columnFilters, setColumnFilters } = useTableState({
        columns,
        initialSort: [{ id: 'tradeDate', desc: true }],
        initialFilters: [{ id: 'pId', value: pId }],
    });

    const { data: closedLotsPage, isPending } = useClosedLots({ pagination, columnFilters, sorting });

    const { columnVisibility, setColumnVisibility, columnOrder, setColumnOrder } =
        useTableColumnSettings('portfolioClosedLots');

    const table = useReactTable({
        data: closedLotsPage?.lots || [],
        columns,
        state: {
            columnVisibility,
            columnOrder,
            pagination,
            sorting,
            columnFilters,
        },
        onColumnFiltersChange: setColumnFilters,
        onColumnVisibilityChange: setColumnVisibility,
        onColumnOrderChange: setColumnOrder,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,
        manualSorting: true,
        manualFiltering: true,
        sortDescFirst: false,
    });

    if (isPending) {
        return (
            <Center width="100%" height="40vh">
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="teal.500" size="lg" />
            </Center>
        );
    }

    return (
        <Box>
            <TableControls table={table} resourceType={ResourceType.LOT} metaData={{ lotType: LotType.CLOSED }} />
            <Table table={table} allowXOverflow />
            <Pagination table={table} totalItems={closedLotsPage?.totalNr} />
        </Box>
    );
};

const EXCLUDE_COLUMNS = ['pId', 'portfolioName', 'householdName', 'portfolioGuid', 'aC'];
const columns = closedLotListColumns.filter((col) => col.id && !EXCLUDE_COLUMNS.includes(col.id));
